var Layout = require("enyo-ui/Layout"),
    kind   = require("enyo/kind");

module.exports = kind(/** @lends  app.ui.header.CoverLayout.prototype */ {

    /**
     * @private
     */
    name: "app.ui.header.CoverLayout",

    /**
     * @private
     */
    kind: Layout,

    /**
     * @public
     */
    reflow: function() {
        var $container       = this.container,
            $playMediaButton = $container.$.playMediaButton,
            coverBounds;

        if (!$container.hasNode()) {
            return;
        }

        coverBounds = $container.getBounds();
        $playMediaButton.$.content.setBounds({
            width:  coverBounds.width / 4 * (coverBounds.height / coverBounds.width),
            height: coverBounds.width / 4 * (coverBounds.height / coverBounds.width)
        });
    }

});
